import { type FC, useEffect, useState } from 'react';

import AudioPlayer from '@/components/AudioPlayer';
import MediaLoader from '@/components/MediaLoader';
import getMediaUrl from '@/helpers/getMediaUrl';
import useNoodleApi from '@/hooks/useNoodleApi';
import { getMediaData } from '@/tsClient';
import { type MediaApiModels } from '@/tsClient/servers/noodleMedia';

type Props = {
  media: Pick<MediaApiModels.Media, 'id' | 'url' | 's3OriginId' | 'transloaditS3Id'>;
};

const MediaAudioPlayer: FC<Props> = ({ media: originalMedia }) => {
  const [media, setMedia] = useState(originalMedia);
  const { getData: getMedia } = useNoodleApi(getMediaData);
  useEffect(() => {
    const refetch = async (): Promise<void> => {
      const { data: newMedia } = await getMedia({ id: media.id });
      if (newMedia?.transloaditS3Id) {
        setMedia(newMedia);
      } else {
        setTimeout(refetch, 10000);
      }
    };
    if (!media.transloaditS3Id) {
      refetch();
    }
  }, [getMedia, media]);
  if (!media.transloaditS3Id) {
    return <MediaLoader isSmall isProcessMessage={true} message='Loading audio...' style={{ maxHeight: 54 }} />;
  }
  return <AudioPlayer audio={{ url: getMediaUrl(media) }} />;
};

export default MediaAudioPlayer;
